<template>
    <transition :css="false" @enter="intro" @leave="outro">
        <router-link
            :to="to"
            class="RoundBttn"
            @mouseenter.native="onMouseEnter"
            @mouseleave.native="onMouseLeave"
        >
            <span class="RoundBttn-container">
                <svg class="RoundBttn-back" ref="back" viewBox="0 0 200 200">
                    <circle cx="100" cy="100" r="99"></circle>
                </svg>
                <span class="RoundBttn-main">
                    <line-icon
                        v-show="iconVisible"
                        class="RoundBttn-icon"
                        :d="icon.d"
                        :width="icon.width"
                        :height="icon.height"
                        :hovered="hovered"
                        dark
                    ></line-icon>
                    <span ref="text" class="RoundBttn-text">
                        <slot></slot>
                    </span>
                </span>
            </span>
        </router-link>
    </transition>
</template>

<script>
import LineIcon from './LineIcon'
export default {
    name: 'RoundBttn',
    props: {
        icon: {
            type: Object,
            required: true,
        },
        to: {
            type: [String, Object],
            required: true,
        },
    },
    components: {
        LineIcon,
    },
    data: () => ({
        hovered: false,
        iconVisible: false,
    }),
    methods: {
        intro(el, done) {
            const { $refs } = this
            TweenLite.set(el, { x: 0, alpha: 1 })
            TweenLite.fromTo($refs.back, 1, {
                rotation: -45,
            }, {
                rotation: 0,
                delay: 1.75,
            })
            TweenLite.fromTo([$refs.back, $refs.text], 1, { alpha: 0 }, {
                alpha: 1,
                delay: 1.75,
                onStart: () => {
                    // Start icon animation until this fade animation starts too
                    this.iconVisible = true
                },
                onComplete: done,
            })
        },
        outro(el, done) {
            TweenLite.to(el, 1, {
                alpha: 0,
                x: 10,
                ease: Cubic.easeOut,
                onComplete: () => {
                    // Avoid line-icon outro
                    this.iconVisible = false
                    done()
                },
            })
        },
        onMouseEnter() {
            this.hovered = true
        },
        onMouseLeave() {
            this.hovered = false
        },
    },
}
</script>

<style src="styles/components/RoundBttn.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/RoundBttn.vue